// # Detect Touch
// `ontouchstart` will work on most browsers. `maxTouchPoints` is a required fallback for IE10/11.

if (
	(typeof window !== 'undefined' && 'ontouchstart' in window) ||
	(typeof navigator !== 'undefined' && navigator.maxTouchPoints)
) {
	// This adds a simple class to the <HTML> element to provide the designer extra direction when scaling interactive elements.
	document.documentElement.className += ' x-touch-enabled';

	// This is a little hack that forces 'taps' to acknowledge the :active psuedo-class, in lieu of :hover when on a touch-screen device.
	// https://css-tricks.com/snippets/css/remove-gray-highlight-when-tapping-links-in-mobile-safari/
	document.addEventListener('touchstart', function() {}, true);
}
